import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import TopbarSidebarButton from "./TopbarSidebarButton";
import TopbarProfile from "./TopbarProfile";
import TopbarLanguage from "./TopbarLanguage";
import TopbarNavPages from "./TopbarNavPages";
import TopbarNotification from "../../Notifications/TopbarNotification";
import urlImageMFV from "../../../assets/img/logo.png";

class Topbar extends PureComponent {
  static propTypes = {
    changeMobileSidebarVisibility: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      imagen: "",
      imagenApp: "",
    };
  }

  componentDidMount() {
    this.loadDataProfile()
      .then((profile) => {
        let url =
          process.env.REACT_APP_PUBLIC_URL +
          "clinica/" +
          profile[0].id_clinica +
          "/logo/" +
          sessionStorage.getItem("token");

        let urlLogo =
          process.env.REACT_APP_PUBLIC_URL +
          "clinica/" +
          "logo_app/" +
          sessionStorage.getItem("token");

        if (profile[0] !== undefined) {
          this.setState({ imagen: url });
          this.setState({ imagenApp: urlLogo });

          let direccion =
            profile[0].direccion.direccion != undefined &&
            profile[0].direccion.direccion != null
              ? profile[0].direccion.direccion
              : "";
          sessionStorage.setItem("logoURL", url);
          sessionStorage.setItem("id_clinica", profile[0].id_clinica); //Guarda el ID de la Clinica
          sessionStorage.setItem("nombre_empresa", profile[0].nombre);
          sessionStorage.setItem("nit_empresa", profile[0].nit);
          sessionStorage.setItem("direccion_empresa", direccion);
          sessionStorage.setItem("telefono_emrpesa", profile[0].telefono1);
          sessionStorage.setItem("id_dpto", profile[0].direccion.id_dpto);
          sessionStorage.setItem("clinica_depcod", profile[0].direccion.depcod);
          sessionStorage.setItem("clinica_ciucod", profile[0].direccion.ciucod);
          sessionStorage.setItem("id_ciudad", profile[0].direccion.id_ciudad);
          sessionStorage.setItem("clinica", JSON.stringify(profile[0]));
          const listTypes = [];

          for (let obj of profile[0].tipo) {
            listTypes.push(obj.value);
          }

          sessionStorage.setItem("centroTipos", JSON.stringify(listTypes));

          //Si tiene una imagen guarde el ID de la Clinica
          if (profile[0].imagen != undefined && profile[0].imagen != null) {
            sessionStorage.setItem("imagen", profile[0].imagen);
          } else {
            sessionStorage.setItem("imagen", null);
          }

          //Consulta del Pais
          fetch(
            process.env.REACT_APP_PUBLIC_URL +
              "clinica/" +
              profile[0].id_clinica +
              "/localidad",
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                authorization: "Bearer " + sessionStorage.getItem("token"),
              },
            }
          )
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              sessionStorage.setItem(
                "localidad",
                JSON.stringify(data.contenido)
              );
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
      })
      .catch((error) => {
        console.log("Error");
      });
  }

  loadDataProfile = () => {
    return new Promise((resolve, reject) => {
      fetch(process.env.REACT_APP_PUBLIC_URL + "clinica/listar", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.length > 0) {
            resolve(data);
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          resolve(error);
        });
    });
  };

  render() {
    const { changeMobileSidebarVisibility } = this.props;

    return (
      <div className="topbar topbar--navigation">
        <div className="topbar__left" style={{ left: 60, background:"white" }} >
          <Link
            className="topbar__logo-link"
            to={`${process.env.PUBLIC_URL}/pages/dashboard`}          >
            <img
              src={urlImageMFV}
              alt="Logo de la Aplicación"
              className="topbar__logo-img"
              style={{
                height: "55px",
                width: "125px",
              }}
            />
          </Link>
        </div>
        <div className="topbar__right">
          <TopbarNavPages />
          <TopbarSidebarButton
            changeMobileSidebarVisibility={changeMobileSidebarVisibility}
          />
          {/* <Link
            style={{ backgroundImage: "url(" + this.state.imagen + ")" }}
            className="topbar__logo"
            to={`${process.env.PUBLIC_URL}/pages/dashboard`}
          ></Link> */}
          {/* <TopbarNotification /> */}
          {/*<TopbarLanguage />*/}
          <TopbarProfile />
        </div>
      </div>
    );
  }
}

export default Topbar;
